export { default, type FullscreenSliderProps } from './FullscreenSlider';
